import { stipAxios } from '../axios';
import { EXTERNAL_CONTEXT } from 'app/config/urls';

const BASE_ENDPOINT = '/dae';

const daeEndpoints = {
    getDAEs: (params, context = EXTERNAL_CONTEXT) => {
        const { page, size, request } = params;
        let endpoint = `${context}${BASE_ENDPOINT}/pages/${page}/${size ? size : 10}`;
        return stipAxios.post(endpoint, request);
    },
    showDAE: (nuAnoGru, nuGru, nuDocumento) => {
        let nuDoc = '';
        if (nuDocumento) {
            nuDoc = nuDocumento;
        }
        return stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/view/${nuAnoGru}/${nuGru}/${nuDoc}`, {
            responseType: 'arraybuffer',
        });
    },
    getStatusDAE: (dePlaca, cdSolicitacao) =>
        stipAxios.get(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/is-paga/${dePlaca}/${cdSolicitacao}`),
    cancelDAE: (dePlaca, cdSolicitacao) =>
        stipAxios.post(`${EXTERNAL_CONTEXT}${BASE_ENDPOINT}/cancelar/${dePlaca}/${cdSolicitacao}`, {}),
};

export default daeEndpoints;
